import { initializeApp } from 'firebase/app';
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  initializeFirestore,
  limit,
  orderBy,
  query,
  runTransaction,
  setDoc,
  updateDoc,
  where
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: 'AIzaSyCWgL9cikqlx4GyCmNJaI9fWqonBiMOBBk',
  authDomain: 'muppadai-book-store.firebaseapp.com',
  projectId: 'muppadai-book-store',
  storageBucket: 'muppadai-book-store.firebasestorage.app',
  messagingSenderId: '636482594986',
  appId: '1:636482594986:web:11218bacbf3fe2425f08d3'
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true
});
export const storage = getStorage(app);
export const auth = getAuth(app);

export const fs = {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  runTransaction,
  setDoc,
  signInWithCustomToken,
  updateDoc,
  where
};
